export default __webpack_public_path__ + "static/media/cal-iusd.7ae6d9ce.svg";